/**
 * Base path alinhado ao next.config.js: sem basePath = '' (app na raiz).
 * Evitar usar '/' como fallback para não gerar URLs com '//' (ex: https://login/).
 */
export const getBasePath = (): string =>
  process.env.NEXT_PUBLIC_BASE_PATH !== undefined ? process.env.NEXT_PUBLIC_BASE_PATH : '';

/** Path absoluto: getBasePath() + p, sem duplicar barra. Ex: pathTo('/login') → '/login' ou '/corporate/login'. */
export const pathTo = (p: string): string => {
  const base = getBasePath();
  return base ? `${base}${p}` : p;
};
